






















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import BaseIcon from '../base-icon/_base-icon.vue';
import { SortOrder } from './enums/sort-order';
import { TableAlign } from './enums/table-align';

export default defineComponent({
  name: 'BaseTableHeaderCell',
  components: {
    BaseIcon,
  },
  props: {
    align: {
      type: String as PropType<TableAlign>,
      default: TableAlign.Left,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String as PropType<SortOrder>,
      default: SortOrder.None,
    },
    dataExternal: {
      type: String,
      default: '',
    },
  },
  setup() {
    return { SortOrder, TableAlign };
  },
});
